import { all, call, fork, takeLatest } from 'redux-saga/effects';

import * as constants from './meeting-archive.constants';
import * as services from './meeting-archive.saga-service';
import { IFetchMeetingArchives, IInitialArchivePage } from './meeting-archive.types';

function* invokeInitialMeetingArchive(action: IInitialArchivePage) {
  yield call(services.fetchMeetingArchive, action.payload);
}

function* invokeFetchMeetingArchives(action: IFetchMeetingArchives) {
  yield call(services.fetchMeetingArchives, action.payload.meetingId, action.payload.queryParams);
}

export function* watchMeetingsArchivePurePageSaga() {
  yield takeLatest(constants.INITIAL_ARCHIVE_PAGE, invokeInitialMeetingArchive);
  yield takeLatest(constants.FETCH_MEETING_ARCHIVE, invokeFetchMeetingArchives);
}

export function* watchMeetingsArchivePageStorageSaga() {
  yield all([watchMeetingsArchivePurePageSaga].map(fork));
}
